const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-traffic-plan" */ '@/pages/financial/tariff/furniture/traffic-plan/index.vue'
  )

const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-traffic-plan" */ '@/pages/financial/tariff/furniture/traffic-plan/create.vue'
  )

const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-traffic-plan" */ '@/pages/financial/tariff/furniture/traffic-plan/edit.vue'
  )

export default {
  name: 'FinancialFurnitureTrafficPlanTariff',
  path: 'traffic-plan',
  meta: {
    label: 'trafficPlanTariff',
    auth: 'trafficPlan'
  },
  component: {
    name: 'TrafficPlan',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialTariffTrafficPlanReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report,
      props: true
    },
    {
      name: 'FinancialCreateTariffTrafficPlan',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialEditTariffTrafficPlan',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
